import React, { useEffect, useState } from "react";
import { ChakraProvider } from "@chakra-ui/react";  // Importar ChakraProvider
import "./styles/globals.css";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import initialTheme from "./theme/theme";
import Index from "./Index";       // Asegúrate de que coincida con el nombre exacto del archivo
import Promotions from "./Promotions/Promotions";
import PromotionSports from "./Promotions/PromotionSports";
import PromotionCasino from "./Promotions/PromotionCasino";
import VipClub from "./VipClub";
import Affiliates from "./Affiliates";
import Leaderboard from "./Leaderboard";
import Forum from "./Forum";
import BlogList from "./Blog/BlogList";
import BlogPostDetail from "./Blog/BlogPostDetail";
import Faqs from "./Faqs";
import Strategy from "./Blog/Strategy/Index";
import Crypto from "./Blog/Crypto";
import HowToGuide from "./Blog/How to Guide";
import StakeNews from "./Blog/Stake News";
import BlogSports from "./Blog/Sports";
import BlogCasino from "./Blog/Casino";
import Other from "./Blog/Other";
import UtfPicks from "./Blog/Utf-Picks";
import Mlb_Predictions from "./Blog/Mlb_prdictions";
import New_Game from "./Blog/New_games";
import Double_Chance_Betting from "./Blog/Double_Chance_Betting/Index";
import Common_Sports_Betting from "./Blog/Common_Sports_Betting";
import New_Games_On_Casino from "./Blog/New_Games_On_Casino";
import Review from "./components/Review/index.js"
import ChampionsLeaguePredictions from "./Blog/Champions_League_Predictions";
import EuropaLeaguePredictions from "./Blog/Europa_League_Predictions";
import PlayStakePokerTournaments from "./Blog/Play_Stake_Poker_Tournaments";
import WhatAreHoldAndWinSlotFeatures from "./Blog/What_are_Hold_And_Win_Slot_Features";
import CornerBetting from "./Blog/Corner_Betting";
import OtherSubBlog from "./Blog/Other_subBlog";
import ResponsibleGambling from "./ResponsibleGambling";
import LiveSupport from "./LiveSupport";
// Routes version V
// import V2Index from "./v2/index";

function App() {
    const [currentTheme, setCurrentTheme] = useState(initialTheme);

    // set the theme to dark explicitly
    localStorage.setItem("chakra-ui-color-mode", "dark");

    // check if the theme is not dark mode then set it to dark explicitly
    useEffect(() => {
        const colorMode = localStorage.getItem("chakra-ui-color-mode");
        if (colorMode !== "dark") {
            localStorage.setItem("chakra-ui-color-mode", "dark");
        }
    }, []);
    return (
        <ChakraProvider>  {/* Envolver la aplicación en ChakraProvider */}
            <Router>
                <Routes>
                    <Route path="/" element={<Index />} />
                    <Route path="/promotions" element={<Promotions />} />
                    <Route path="/promotions/sports" element={<PromotionSports />} />
                    <Route path="/promotions/casino" element={<PromotionCasino />} />
                    <Route path="/vipclub" element={<VipClub />} />
                    <Route path="/affiliates" element={<Affiliates />} />
                    <Route path="/leaderboard" element={<Leaderboard />} />
                    <Route path="/forum" element={<Forum />} />
                    <Route path="/faqs" element={<Faqs />} />
                    <Route path="/blog" element={<BlogList />} />
                    <Route path="/blog/:id" element={<BlogPostDetail />} />
                    <Route path="/responsibleGambling" element={<Navigate to="/responsibleGambling/Overview" />} />
                    <Route
                        path="/responsibleGambling/:sectionName"
                        element={<ResponsibleGambling />}
                    />
                    <Route path="/livesupport" element={<LiveSupport />} />

                    {/*  Route version V  */}

                    {/*<Route path="/v2" element={<V2Index />} />*/}

                </Routes>
            </Router>
        </ChakraProvider>
    );
}

export default App;
